var map = {
	"./arrow-down.svg": "1f5d",
	"./arrow-up.svg": "a4f5",
	"./behance.svg": "bcfe",
	"./dribbble.svg": "18dc",
	"./github.svg": "8211",
	"./linkedin.svg": "277b",
	"./website.svg": "1076"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";